import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import API_BASE from '../utils/apiBase';

const containerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { staggerChildren: 0.08, delayChildren: 0.2 } }
};
const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const AdminApplicationsList = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/api/job_applications.php`)
      .then(res => res.json())
      .then(data => {
        setApplications(data.applications || []);
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4" style={{ marginTop: "90px" }}>
      <div className="max-w-4xl mx-auto bg-black rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Job Applications</h2>
        {loading ? (
          <div className="text-center text-gray-500">Loading...</div>
        ) : applications.length === 0 ? (
          <div className="text-center text-gray-500">No applications found.</div>
        ) : (
          <motion.div
            className="space-y-4"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {applications.map(app => (
              <motion.div
                key={app.id}
                className="bg-gray-100 rounded p-4 flex flex-col md:flex-row md:items-center md:justify-between shadow"
                variants={itemVariants}
              >
                <div>
                  <div className="font-semibold text-lg text-gray-700">{app.name}</div>
                  <div className="text-gray-600 text-sm">{app.email} | {app.birthdate}</div>
                  <div className="text-gray-600 text-sm">Position: <span className="font-medium">{app.position}</span></div>
                  <div className="text-gray-600 text-sm">Work Ex: {app.workex}</div>
                  <div className="text-gray-600 text-sm">Message: {app.message}</div>
                  <div className="text-gray-500 text-xs mt-1">Applied: {app.applied_at}</div>
                </div>
                <div className="mt-2 md:mt-0 md:ml-4 flex flex-col items-end">
                  {app.file_url && (
                    <a
                      href={`http://localhost:8000/${app.file_url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline text-sm font-medium"
                    >
                      Download CV
                    </a>
                  )}
                </div>
              </motion.div>
            ))}
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default AdminApplicationsList;
